import "@fortawesome/fontawesome-free/js/all.js"
import "./foundation.js"
import "./fontLoad.js"
import "./menu-catalog-sections.js"
import "./carousels.js"
import "./carousels-swipe.js"
import "./clients.js"
import "./handleSidebar.js"
//import "./customScrollbar.js"
import "./handleAddressInput.js"
import "./accordionTabs.js"
import "foundation-sites"
import "slick-carousel"
//import "@fancyapps/fancybox"


function getCookie(name) {
  var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

import "./replaceImgSvg.js"
import "./handleBasket.js"
import "./equalizer.js"
import customSelect from "custom-select/src"
import "../scss/style.scss"
;(function ($) {
  "use strict"
  window.$ = window.jQuery = $
  window.customSelect = customSelect
  window.currentScrollY = window.scrollY;

  // Set menu entity active
  if ( document.location.pathname === '/' ) {
      $('a.app:nth(0)').addClass('active');
  } else {
      $('a.app').each(function() {
          if ( document.location.pathname.match(this.attributes.href.value) ) {
              $(this).addClass('active');
          }
      });
  }

  $(document).on("click", '[data-action="change-popup-panel"]', function (e) {
    e.stopPropagation()
    e.preventDefault()
    $(document)
      .find('[data-popup-panel="user-address"]')
      .fadeOut(200, function () {
        $(document).find('[data-popup-panel="delivery-branch"]').fadeIn(200)
      })
  })

  $(document).on('scroll', e => {
      let $menu = $('.rack');
      let direction = window.scrollY > window.currentScrollY ? 'down' : 'up';
      let scrollValue = direction === 'down' ? window.scrollY - window.currentScrollY : window.currentScrollY - window.scrollY;
      let menuScrollValue = $menu.offset().top;

      if ( direction === 'down' ) {
          $menu.scrollTop(menuScrollValue + scrollValue);
      } else {
          $menu.scrollTop(menuScrollValue - scrollValue);
      }

      window.currentScrollY = window.scrollY;
  });

  let nYearMenu = $(document).find("#new-year-menu")
  if (nYearMenu.length !== 0) {
    nYearMenu.foundation("open")
  }
  if ($(document).find('.x-garnish-select').length) {
    $(document).find('.x-garnish-select').each(function () {
      let selectValue = getCookie('garnish-select-' + $(this).parents('.x-product-box').data('id')),
        $select = $(this).find(":selected");

      if (
        $select.data('offer') !== selectValue
        &&
        $(this).find("[data-offer=" + selectValue + "]").length
      ) {
        $(this).val(selectValue);
      }
    });
  }
  let $customSelectProductsGarnish = window.customSelect(".x-garnish-custom-select", {
    containerClass: "garnish__container",
    openerClass: "garnish__opener",
    panelClass: "garnish__panel",
    optionClass: "garnish__option",
    optgroupClass: "custom-select-optgroup",
    isSelectedClass: "is-selected",
    hasFocusClass: "has-focus",
    isDisabledClass: "is-disabled",
    isOpenClass: "is-open",
  })
  if ($customSelectProductsGarnish.length) {
    $(document)
      .find(".x-garnish-custom-select")
      .each(function () {
        $(this).removeClass("x-garnish-custom-select")
      })
    $customSelectProductsGarnish.forEach(function (item, key) {
      $customSelectProductsGarnish[key].container.addEventListener("custom-select:close", (e) => {
        window.changeOfferGarnish()
      })
    })
  }

  var $customSelectProductGarnish = window.customSelect(".x-product-garnish-select", {
    containerClass: "product__garnish-container",
    openerClass: "product__garnish-opener",
    panelClass: "product__garnish-panel",
    optionClass: "product__garnish-option",
    optgroupClass: "custom-select-optgroup",
    isSelectedClass: "is-selected",
    hasFocusClass: "has-focus",
    isDisabledClass: "is-disabled",
    isOpenClass: "is-open",
  })
  if ($customSelectProductGarnish.length) {
    $customSelectProductGarnish.forEach(function (item, key) {
      $customSelectProductGarnish[key].container.addEventListener("custom-select:close", (e) => {
        window.changeOfferGarnish()
      })
    })
  }

  window.customSelect($('[data-select="branch-select"]'), {
    containerClass: "branch__container",
    openerClass: "branch__opener",
    panelClass: "branch__panel",
    optionClass: "branch__option",
    optgroupClass: "custom-select-optgroup",
    isSelectedClass: "is-selected",
    hasFocusClass: "has-focus",
    isDisabledClass: "is-disabled",
    isOpenClass: "is-open",
  })

  $(function () {
    $(document).find(".restoraunts__carousel").slick({
      autoplay: true,
      speed: 500,
      adaptiveHeight: false,
      arrows: false,
      dots: true,
    })

    $(document)
      .find('[data-entity="section-banner"]')
      .slick({
        autoplay: true,
        speed: 500,
        adaptiveHeight: false,
        arrows: true,
        dots: true,
        prevArrow: $(".sectionbanner__prev"),
        nextArrow: $(".sectionbanner__next"),
      })

    if (window.sessionStorage.getItem("hideDiscountPopup") !== "Y" && $(document).find("#catcherModal").length) {
      $(document).mousemove(function (e) {
        if (window.sessionStorage.getItem("hideDiscountPopup") !== "Y") {
          if (e.pageY <= 5) {
            $(document).find("#catcherModal").foundation("open")
            window.sessionStorage.setItem("hideDiscountPopup", "Y")
          }
        }
      })
    }
  })
})(jQuery)
